import { render } from "./ListCopyAgendaView.vue?vue&type=template&id=8b2d784c"
import script from "./ListCopyAgendaView.vue?vue&type=script&lang=js"
export * from "./ListCopyAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__